// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__1JkAi","slider":"ToggleSwitch_slider__yKdnW"};